export enum GlobalHeaderThemesEnum {
  simple = 'simple',
  action_packed = 'action_packed', // lolz...
  ia_nav = 'ia_nav',
  ia_nav_insights_hub = 'ia_nav_insights_hub',
}
